import React from "react";

function Title() {
  return (
    <div className="row-start-1 row-end-2 col-start-1 col-end-13 grid grid-rows-2 grid-cols-1 justify-items-center">
      <h2 className="row-start-1 row-end-2 col-start-1 col-end-2 text-center font-athiti text-2xl font-bold">
        Ausstattung
      </h2>
      <div className="row-start-2 row-end-3 col-start-1 col-end-2 border-t border-black w-4/12" />
    </div>
  );
}

export default Title;
